/* eslint-disable @nx/enforce-module-boundaries */
import { DebtType } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { Button } from '@axo/ui-core/components/Button';
import { Icon } from '@axo/ui-core/components/Icon';
import { Message } from '@axo/ui-core/components/Message';
import { useCallback } from 'react';
import { useESkat } from '../../../../ESkat';
import { DebtCollectionFormGroup } from './DebtCollectionFormGroup';
import { DebtList } from './DebtList';
import { ExtraDebtFormGroup } from './ExtraDebtFormGroup';
import { useDebts } from './hooks/useDebts';

export function DebtFormGroup() {
  const { t } = useTranslation();

  const { logged: isESkat } = useESkat();

  const { debts, editingDebtIndex, addDebt, editDebt, removeDebt } = useDebts();

  const hasDebtCollection = debts.some(
    (debt) => debt.Type === DebtType.Collection
  );

  const onAddDebt = useCallback(() => {
    addDebt();
  }, [addDebt]);

  return (
    <>
      <DebtList
        debts={debts}
        editingDebtIndex={editingDebtIndex}
        hasDebtCollection={hasDebtCollection}
        onEdit={editDebt}
        onRemove={removeDebt}
      />

      <Button
        variant="primary"
        suffix={<Icon name="plus-circle" />}
        onClick={onAddDebt}
        data-testid="add-debt-button"
      >
        {t('Debts.add')}
      </Button>

      {debts?.length > 0 && (
        <Message hasIcon variant="info">
          {t('Debts.warning', { context: isESkat ? 'eskat' : 'manual' })}
        </Message>
      )}

      <ExtraDebtFormGroup debts={debts} />

      {!isESkat && (
        <DebtCollectionFormGroup onAdd={addDebt} onRemove={removeDebt} />
      )}
    </>
  );
}
